import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AlertifyService } from 'src/app/services/alertify.service';
import { EmpresaService } from 'src/app/services/empresa.service';
import { PlanService } from 'src/app/services/plan.service';

@Component({
  selector: 'app-create-edit-plan',
  templateUrl: './create-edit-plan.component.html',
  styleUrls: ['./create-edit-plan.component.scss']
})
export class CreateEditPlanComponent implements OnInit {
  registerForm: UntypedFormGroup;
  public isForEdit = false;
  public dataInput: any;
  public tituloTxt = 'Crear plan';

  constructor(
    public planSvc: PlanService,
    private alertify: AlertifyService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<CreateEditPlanComponent>
  ) {
    this.dataInput = data;
    console.log('los datos de ingreso son: ', data);
    if (data != null) {
      this.isForEdit = true;
      this.tituloTxt = 'Editar plan';
    }
  }

  ngOnInit(): void {
    this.registerForm = new UntypedFormGroup({
      id: new UntypedFormControl(''),
      nombre: new UntypedFormControl('', Validators.required),
      descripcion: new UntypedFormControl(''),
      mesesDeVigencia: new UntypedFormControl('',[Validators.required, Validators.min(1)]),
      valor: new UntypedFormControl('',[Validators.required, Validators.min(0)]),

     // valorSticker: new FormControl(''),
    });

    if (this.isForEdit) {
      this.registerForm.get('id')?.setValue(this.dataInput.planId);
      this.registerForm
        .get('nombre')
        ?.setValue(this.dataInput.nombre);
      this.registerForm.get('descripcion')?.setValue(this.dataInput.descripcion);
      this.registerForm.get('mesesDeVigencia')?.setValue(this.dataInput.mesesDeVigencia);
      this.registerForm.get('valor')?.setValue(this.dataInput.valor);

      
    }
  }

  guardar() {
    console.log('guardar plan');
    console.log(this.registerForm.value);
    if (this.isForEdit) {
      //aqui mando a editar
      this.planSvc.EditPlan(this.registerForm.value).subscribe((res) => {
        console.log('resultado Editar: ', res);
        if (res) {
          this.alertify.success('Plan actualizado');
          this.dialogRef.close(true);
        } else {
          this.alertify.error('El plan no se ha podido actualizar');
        }
      });
    } else {
      //aqui mando a crearlo
      this.registerForm
        .get('id')
        ?.setValue('00000000-0000-0000-0000-000000000000');
        console.log(this.registerForm.value);
      this.planSvc.AddPlan(this.registerForm.value).subscribe((res) => {
        console.log('resultado crear: ', res);
        if (res) {
          this.alertify.success('Plan creado');
          this.dialogRef.close();
        } else {
          this.alertify.error(
            'El plan ya existe, valide la información e intentelo de nuevo'
          );
        }
      });
    }
  }

}
